<div class="text-center" *ngIf="user['expandFunctions'] == true">
  <div *ngIf="plansArr" class="text-right mr-2"><span><i class="fas fa-info-circle text-success"></i></span>
    {{ user['activityStr'] }} {{ user['firstName']}} on
    {{ user['planDate'] | date: 'MM/dd hh:mm' }}
    <br>
    <span class="text-success"> {{ user['assignerComment'] }} </span>
    <br>
  </div>
  <div *ngIf="user['confirmView'] == true && user['editView'] == false" class="text-center">
    <h5 *ngIf="plansArr">Is Task Complete?</h5>
    <h5 *ngIf="! plansArr">Record in Activity History?</h5>
    <br>
    <div class="col-9 col-lg-3 mx-auto">
      <button class="btn btn-success btn-block my-3" (click)="DefaultTask(user)"> <span
          *ngIf="completingTask == false">{{ getRecordMessage(user) }}</span>
        <span *ngIf="completingTask == true"><i class="fas fa-spinner fa-spin"></i></span>
      </button>
      <button class="btn btn-primary btn-block my-3" (click)="user['confirmView'] = false;user['editView'] = true"> Edit
        Task </button>
      <button class="btn btn-secondary btn-block my-3" (click)="user['confirmView'] = false;user['editView'] = false">
        <span>{{ globalService.Get("NO") }}</span> </button>
      <br>
    </div>
  </div>
</div>
<div *ngIf="user['expandFunctions'] == true && user['editView'] == true && user['confirmView'] == false">
  <div class="row">
    <div class="col-12" [class.text-right]="globalService.isRTL == true">
      <label for="task" class="text-secondary text-center" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("TASK") }}</label>
      <select class="form-control" [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false" [(ngModel)]="user['activity']"
        [ngModelOptions]="{standalone: true}">
        <option [ngValue]="0" selected>
          {{ globalService.Get("VISIT") }}
        </option>
        <option [ngValue]="1">
          {{ globalService.Get("CALL") }}
        </option>
        <option [ngValue]="2">
          {{ globalService.Get("TEXT") }}
        </option>
        <option [ngValue]="3">
          {{ globalService.Get("EMAIL") }}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-12" [class.text-right]="globalService.isRTL == true">
      <label for="status" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("STATUS") }}</label>
      <select id="status" class="form-control" [class.classicRTL]="globalService.isRTL == true"
        (change)="statusChanged()" [class.classic]="globalService.isRTL == false" [(ngModel)]="user['status']"
        [ngModelOptions]="{standalone: true}">
        <option [ngValue]="0" selected>
          {{ globalService.Get("PLANNED") }}
        </option>
        <option [ngValue]="1">
          {{ globalService.Get("COMPLETE") }}
        </option>
        <option [ngValue]="2">
          {{ globalService.Get("DENIED") }}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-6 col-lg-3 col-xl-2" [class.text-right]="globalService.isRTL == true">
      <label for="date" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("DATE") }}</label>
      <input name="date" type="date" class="form-control" [(ngModel)]="user['actualDate']"
        [ngModelOptions]="{standalone: true}" />
    </div>
    <div class="col-6 col-lg-3 col-xl-2">
      <label for="date" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("TIME") }}</label>
      <input type="time" id="startTime" class="form-control" [(ngModel)]="user['timeStr']"
        [ngModelOptions]="{standalone: true}" />
    </div>
  </div>
  <div class="row">
    <div class="col-12" [class.text-right]="globalService.isRTL == true">
      <label for="note" class="text-secondary" [class.SmallArabicFont]="globalService.isRTL == true">{{
        globalService.Get("NOTE") }}</label>
      <textarea class="form-control" rows="3" [(ngModel)]="user['assigneeComment']"
        [ngModelOptions]="{standalone: true}" autocomplete="off"></textarea>
    </div>
  </div>
  <br>
  <div class="col-12">
    <button class="col-4 btn btn-primary mx-2" (click)="CompleteTask(user)"><span *ngIf="completingTask == false">
        {{ getRecordMessage(user) }}</span>
      <span *ngIf="completingTask == true"><i class="fas fa-spinner fa-spin"></i></span></button>
    <button class="col-4 btn btn-secondary mx-2"
      (click)="user['editView'] = false; user['confirmView'] = true; user['activityStr']=''">Back</button>
  </div>  
  <br>
</div>
<app-user-tools *ngIf="user['confirmView'] == false && user['editView'] == true && user.expandFunctions" [user]="user" [subdomain]="subdomain" 
  (actionClicked)="confirmAction($event)">
</app-user-tools>